import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './services/api/interceptor/interceptor.service';
import { MockApiInterceptor } from './services/api/mock/mock-api.interceptor';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withFetch()),
    provideHttpClient(withInterceptorsFromDi()),
    provideClientHydration(),
    provideAnimationsAsync(),
    // Must precede TokenInterceptor: a mocked request short-circuits here,
    // before any auth header or 401-refresh handling runs. Inert unless the
    // `mock` build configuration is used.
    {provide:HTTP_INTERCEPTORS, useClass:MockApiInterceptor, multi:true},
    {provide:HTTP_INTERCEPTORS, useClass:TokenInterceptor, multi:true},
    provideCharts(withDefaultRegisterables())
  ],
};
